import axios from "../axios";
import hostConfig from "@/config/hostResolver";

const baseUrl =
  process.env.VUE_APP_SLACK_URL ?? `${hostConfig.apiBaseUrl}/integration-slack-service`;

class SlackService {
  storeSlackWorkspaceAssociation(correlationId) {
    console.log(`${baseUrl}/correlate/workspace?correlationId=${correlationId}`);
    return axios
      .post(`${baseUrl}/correlate/workspace?correlationId=${correlationId}`)
      .then((response) => {
        console.log("Slack association response ", response.data);
        return response.data;
      })
      .catch((error) => {
        console.log("Error posting slack association ", error);
        return error;
      });
  }
  storeSlackUserAssociation(correlationId) {
    console.log(`${baseUrl}/correlate/user?correlationId=${correlationId}`);
    return axios
      .post(`${baseUrl}/correlate/user?correlationId=${correlationId}`)
      .then((response) => {
        console.log("Slack association response ", response.data);
        return response.data;
      })
      .catch((error) => {
        console.log("Error posting slack association ", error);
        throw error;
      });
  }
}

export default new SlackService();
